module.exports = __webpack_public_path__ + "static/img/11教育网@2x.3555e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partners/11教育网@2x.png
// module id = Vg+k
// module chunks = 1